import React from "react";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/noVisitAfterFirstVisitSagas";

const TimePeriod = () => {
  const dispatch = useDispatch();

  const { period_days, timeOptions } = useSelector((state) => {
    const {
      selectedFilters: { period_days },
      timeOptions
    } = state.noVisitAfterFirstVisit;
    return { period_days, timeOptions };
  }, shallowEqual);

  return (
    <MultiSelectDropdown
      options={timeOptions}
      selectedFilters={period_days}
      includeFilter={false}
      onSelectChange={(data) => dispatch(actionCreators.updatePeriodDays(data))}
    />
  );
};
export default TimePeriod;
